import React from "react";
import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Users, MessageSquare, FileText, LogOut, RefreshCw } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "/admin/produits", label: "Produits", icon: Package },
  { to: "/admin/usages", label: "Usagés", icon: RefreshCw },
  { to: "/admin/commandes", label: "Commandes", icon: ShoppingCart },
  { to: "/admin/clients", label: "Clients payés", icon: Users },
  { to: "/admin/messages", label: "Messages", icon: MessageSquare },
  { to: "/admin/articles", label: "Articles", icon: FileText },
];

export default function AdminLayout() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  if (admin === null) return <div className="min-h-screen flex items-center justify-center text-gray-400">Chargement…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen flex bg-gray-50">
      <aside className="w-64 bg-[#0a0a0a] text-white flex flex-col shrink-0">
        <div className="p-6 border-b border-white/10">
          <img src="/logo.png" alt="DCS Electro" className="h-9 bg-white p-1.5 rounded-sm" />
          <p className="text-xs text-gray-500 mt-3">CRM · {admin.email}</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 text-sm rounded-sm transition-colors ${isActive ? "bg-sapphire text-white" : "text-gray-400 hover:bg-white/5 hover:text-white"}`}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-").replace(/é/g, "e")}`}>
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={async () => { await logout(); navigate("/admin/login"); }} className="flex items-center gap-3 px-8 py-4 text-sm text-gray-400 hover:text-white border-t border-white/10" data-testid="admin-logout">
          <LogOut size={18} /> Déconnexion
        </button>
      </aside>
      <main className="flex-1 overflow-auto"><div className="p-8"><Outlet /></div></main>
    </div>
  );
}
